import "./sentry";
import {createRoot} from "react-dom/client";
import {AccountsApp} from "./AccountsApp";
import "@wakelet/ui-kit/dist/index.esm.css"
import languages from "../languages.json";
import {initReactI18next, withTranslation} from "react-i18next";
import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import {getCurrentLang} from "./components/language/LanguageSelector";
import {Suspense} from "react";
import {SuspensePage} from "./pages";
import {getEnv} from "./env/env";
import {auth} from "./firebase/firebase-config";

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

console.info(`starting accounts: ${getEnv()}`);

i18n
.use(HttpApi)
.use(initReactI18next) // passes i18n down to react-i18next
.init({
  ns: ["common", "account", "settings"],
  lng: getCurrentLang(),
  defaultNS: "common",
  debug: false,
  backend: {
    // eslint-disable-next-line no-path-concat
    loadPath: `https://assets.wakelet.com/locales/${languages.version.current}/{{lng}}/{{ns}}.json`,
  },
  load: "currentOnly",
  fallbackLng: "en-US",
  react: {useSuspense: true},
  preload: ["en-US"],
  parseMissingKeyHandler: () => "",
});


const TranslatedApp = withTranslation()(AccountsApp);
const AppWithSuspense = () => <Suspense fallback={<SuspensePage/>}><TranslatedApp auth={auth}/></Suspense>

const container = document.getElementById("accounts-root");
const root = createRoot(container as HTMLElement)
root.render(<AppWithSuspense/>);
